import { useEffect, useState } from 'react';
import { parseCookies } from 'nookies';

export function useHasLoginToken(): boolean {
  const [hasLoginToken, setHasLoginToken] = useState(false);

  useEffect(() => {
    const cookies = parseCookies();
    setHasLoginToken(Boolean(cookies['@crewlink:tk']));
  }, []);

  return hasLoginToken;
}
